import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { cn } from "./cn";
export function Empty({ className, ...props }) {
    return (_jsx("div", { "data-slot": "empty", className: cn("flex min-h-52 flex-col items-center justify-center gap-2 rounded-lg border border-dashed p-8 text-center", className), ...props }));
}
export function EmptyHeader({ className, ...props }) {
    return (_jsx("div", { className: cn("flex max-w-sm flex-col items-center gap-1", className), ...props }));
}
export function EmptyMedia({ className, ...props }) {
    return (_jsx("div", { className: cn("mb-2 grid size-10 place-items-center rounded-lg bg-muted text-muted-foreground [&_svg]:size-5", className), ...props }));
}
export function EmptyTitle({ className, ...props }) {
    return (_jsx("h3", { className: cn("font-medium text-foreground", className), ...props }));
}
export function EmptyDescription({ className, ...props }) {
    return (_jsx("p", { className: cn("text-sm leading-6 text-muted-foreground", className), ...props }));
}
//# sourceMappingURL=empty.js.map